import { render, staticRenderFns } from "./main-nav.vue?vue&type=template&id=5eba9089&"
import script from "./main-nav.vue?vue&type=script&lang=ts&"
export * from "./main-nav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports